import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import queryString from 'qs';
import map from 'lodash.map';
import { ProjectActionCreators, AppActionCreators } from '../../../actions';
import { ProjectList } from '../Project/ProjectList';
import { RouteUrls } from '../../../configs/routeUrls';
import { ProjectType } from '../../../utils/enums';

class ProjectListContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			page: 1,
			size: props.pageSize,
			archiveListPage: 1,
			archiveListSize: props.archiveListSize
		};
		this.type = props.type;
		this.listUrl = props.listUrl;
		this.voteUrl = props.voteUrl;
		this.previewUrl = props.previewUrl;

		this.onSearchProjects = this.onSearchProjects.bind(this);
		this.onSearchArchiveProjects = this.onSearchArchiveProjects.bind(this);
		this.onRedirectToPreview = this.onRedirectToPreview.bind(this);
		this.onRedirectToVote = this.onRedirectToVote.bind(this);
	}

	componentDidMount() {
		this.props.fetchProjectsByType(this.type, {
			page: this.state.page,
			size: this.props.pageSize,
			archiveListPage: this.state.archiveListPage,
			archiveListSize: this.props.archiveListSize
		});
		this.props.fetchArchiveProjectsByType(this.type, {
			page: this.state.page,
			size: this.props.pageSize,
			archiveListPage: this.state.archiveListPage,
			archiveListSize: this.props.archiveListSize
		});
		this.props.setBreadcrumbs([ this.getProjectTypeSettings(this.type) ]);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.pageSize !== this.props.pageSize) {
			const filter = queryString.parse(window.location.search, { ignoreQueryPrefix: true });
			this.setState({
				page: 1,
				size: this.props.pageSize
			});
			this.props.fetchProjectsByType(this.type, {
				...filter,
				page: 1,
				size: this.props.pageSize,
				isActual: true,
				archiveListPage: this.state.archiveListPage,
				archiveListSize: this.props.archiveListSize
			});
		}
		if (prevProps.archiveListSize !== this.props.archiveListSize) {
			const filter = queryString.parse(window.location.search, { ignoreQueryPrefix: true });
			this.setState({
				archiveListPage: 1,
				archiveListSize: this.props.archiveListSize
			});
			this.props.fetchArchiveProjectsByType(this.type, {
				...filter,
				page: this.state.page,
				size: this.props.pageSize,
				isActual: false,
				archiveListPage: 1,
				archiveListSize: this.props.archiveListSize
			});
		}
	}

	onRedirectToVote(id) {
		this.props.goTo(`${this.voteUrl}/${id}`);
	}

	onRedirectToPreview(id) {
		this.props.goTo(`${this.previewUrl}/${id}`);
	}

	onSearchProjects(filter) {
		this.props.fetchProjectsByType(this.type, {
			...filter
		});
	}

	onSearchArchiveProjects(filter) {
		this.props.fetchArchiveProjectsByType(this.type, {
			...filter
		});
	}

	getProjectTypeSettings(type) {
		switch (type) {
			case ProjectType.Consultation:
				return {
					url: RouteUrls.Consultation.list,
					displayName: 'Konsultacje'
				};
			case ProjectType.Survey:
				return {
					url: RouteUrls.Survey.list,
					displayName: 'Ankiety'
				};
			case ProjectType.Probe:
				return {
					url: RouteUrls.Probe.list,
					displayName: 'Sondy'
				};
			default:
				return {
					url: '',
					displayName: ''
				};
		}
	}

	render() {
		let query = queryString.parse(this.props.location.search, { ignoreQueryPrefix: true });
		const { page = 1, archiveListPage = 1 } = query;
		const { size, archiveListSize } = this.state;
		const {
			isAuth,
			isProjectListLoading,
			isSearching,
			isCancelButtonVisible,
			isArchiveProjectLoading,
			isOnlyOneOffice,
			voteExecuting,
			loggedOfficeId,
			loggedUserId,
			thematicAreas,
			projects,
			archiveProjects,
			totalProjects,
			totalArchiveProjects,
			projectModes,
			publishProgress,
			setPageSize,
			setArchivePageSize,
			expand,
			setExpandStateItem,
			loggedUserIsCitizen
		} = this.props;

		return (
			<ProjectList
				projectType={this.type}
				isAuth={isAuth}
				isProjectListLoading={isProjectListLoading}
				isSearching={isSearching}
				isCancelButtonVisible={isCancelButtonVisible}
				isArchiveProjectLoading={isArchiveProjectLoading}
				isOnlyOneOffice={isOnlyOneOffice}
				voteExecuting={voteExecuting}
				loggedOfficeId={loggedOfficeId}
				loggedUserId={loggedUserId}
				loggedUserIsCitizen={loggedUserIsCitizen}
				thematicAreas={thematicAreas}
				projects={projects}
				archiveProjects={archiveProjects}
				page={page}
				size={size}
				archiveListPage={archiveListPage}
				archiveListSize={archiveListSize}
				totalProjects={totalProjects}
				totalArchiveProjects={totalArchiveProjects}
				expand={expand}
				availableProjectModes={map(projectModes, function(item) {
					return {
						value: item.name,
						label: item.name
					};
				})}
				availablePublishProgress={map(publishProgress, function(item) {
					return {
						value: item.name,
						label: item.name
					};
				})}
				changePageSize={setPageSize}
				changeArchivePageSize={setArchivePageSize}
				onSearchProject={this.onSearchProjects}
				onSearchArchiveProject={this.onSearchArchiveProjects}
				onProjectPreview={this.onRedirectToPreview}
				onProjectVote={this.onRedirectToVote}
				onSaveProjectVote={(projectId, consultationForms) =>
					this.props.updateConsultationForm(projectId, consultationForms)}
				onSetExpandStateItem={setExpandStateItem}
			/>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		isAuth: state.app.isAuth,
		isProjectListLoading: state.project.isProjectListLoading,
		isSearching: state.app.isSearching,
		isCancelButtonVisible: false,
		isArchiveProjectLoading: state.project.isArchiveProjectLoading,
		isOnlyOneOffice: state.app.offices && state.app.offices.length === 1,
		voteExecuting: state.project.voteExecuting,
		loggedOfficeId: state.app.loggedUser.officeId,
		loggedUserId: state.app.loggedUser.userId,
		loggedUserIsCitizen: state.app.loggedUser.isCitizen || false,
		thematicAreas: state.app.thematicAreas,
		projects: state.project.projects,
		archiveProjects: state.project.archiveProjects,
		pageSize: state.app.pageSize,
		archiveListSize: state.app.archivePageSize,
		totalProjects: state.project.totalProjects,
		totalArchiveProjects: state.project.totalArchiveProjects,
		projectModes: state.app.projectModes,
		publishProgress: state.app.publishProgress,
		expand: state.app.expand
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		...bindActionCreators({ ...ProjectActionCreators, ...AppActionCreators }, dispatch),
		...{ goTo: (url) => dispatch(push(url)) }
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectListContainer);
